import { render, staticRenderFns } from "./ITRInsuranceCard.vue?vue&type=template&id=64a54d69&scoped=true&"
import script from "./ITRInsuranceCard.vue?vue&type=script&lang=ts&"
export * from "./ITRInsuranceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a54d69",
  null
  
)

export default component.exports